<template>
  <div>
    <search-area tabName="优惠券列表" searchAdd @search="search" @add="add">
      <Form
        ref="searchParam"
        :model="searchParam"
        :label-width="55"
        inline
        label-position="right"
        label-colon
      >
        <FormItem label="优惠券名称" prop="name" :label-width="105">
          <Input
            v-model="searchParam.name"
            placeholder="请输入优惠券名称"
            style="width: 200px"
            clearable
          ></Input>
        </FormItem>
      </Form>
    </search-area>
    <table-area
      :columns="columns"
      :data="couponList"
      :total="total"
      @search="search"
      :pageNum="searchParam.currentPage"
      :pageSize="searchParam.pageSize"
    ></table-area>
    <el-dialog
      :title="detailFlag ? '优惠券明细' : '新增优惠券'"
      top="50px"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="showNewDialog"
      @close="closeNewDialog"
    >
      <el-form
        ref="formData"
        :rules="newRuler"
        :model="formData"
        :hide-required-asterisk="false"
      >
        <el-form-item label="优惠券名称" label-width="120px" prop="name">
          <el-input
            size="medium"
            placeholder="请输入优惠券名称"
            style="width: 200px"
            v-model="formData.name"
            autocomplete="off"
            :disabled="detailFlag"
          ></el-input>
        </el-form-item>
        <el-form-item label="优惠方式" label-width="120px" prop="type">
          <el-radio-group v-model="formData.type" :disabled="detailFlag">
            <el-radio :label="1">满减</el-radio>
            <!-- <el-radio :label="2">折扣</el-radio> -->
            <!-- <el-radio :label="3">免息</el-radio> -->
          </el-radio-group>
        </el-form-item>
        <el-form-item label="优惠金额" label-width="120px" prop="reduce">
          <el-input
            size="medium"
            style="width: 200px"
            placeholder="请输入金额（支持小数点）"
            v-model="formData.reduce"
            type="text"
            :disabled="detailFlag"
            min="0"
          ></el-input>
        </el-form-item>
        <el-form-item label="满减条件" label-width="120px" prop="full"
          >金额 > =
          <el-input
            size="medium"
            style="width: 200px"
            v-model="formData.full"
            placeholder="请输入金额（支持小数点）"
            type="text"
            min="0"
            :disabled="detailFlag"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="有效期" prop="validDate" label-width="120px">
          <el-date-picker
            style="margin-bottom: 10px"
            v-model="formData.validDate"
            class="picker"
            :disabled="detailFlag"
            size="medium"
            type="datetimerange"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            :editable="false"
            :clearable="false"
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="优惠券类型" prop="useType" label-width="120px">
          <el-radio-group v-model="formData.useType" disabled>
            <el-radio :label="0">全场通用</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="说明" label-width="120px">
          <el-input
            size="medium"
            style="width: 200px"
            type="textarea"
            :disabled="detailFlag"
            v-model="formData.description"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="d-flex flex-center">
        <el-button size="small" @click="showNewDialog = false"
          >{{ detailFlag ? "关 闭" : "取 消" }}
        </el-button>
        <el-button
          type="primary"
          size="small"
          @click="onSubmit"
          v-if="!detailFlag"
          >确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import columns from "./coupon-column";
export default {
  data() {
    return {
      columns: columns(this),
      // 列表数据总数
      total: 1,
      // 加载中
      loading: false,
      // 搜索参数
      searchParam: {
        currentPage: 1,
        pageSize: 10,
        name: "",
      },
      detailFlag: false, // 是否是详情
      couponList: [],
      newRuler: {
        name: [
          { required: true, message: "请输入优惠券名称", trigger: "blur" },
          { max: 20, message: "长度小于20个汉字", trigger: "blur" },
        ],
        type: [
          { required: true, message: "请选择优惠券类型", trigger: "blur" },
        ],
        reduce: [
          { required: true, message: "请输入优惠数额", trigger: "blur" },
        ],
        full: [{ required: true, message: "请完善使用条件", trigger: "blur" }],
        validDate: [
          { required: true, message: "请选择有效期", trigger: "blur" },
        ],
      },
      formData: {
        name: "", // 名称
        reduce: "", // 优惠价格
        validDate: [],
        type: 1,
        isNewcomer: 1,
        full: "", // 满减的最小价格
        description: "", // 说明
        useType: 0,
      },
      showNewDialog: false,
    };
  },
  computed: {},
  created() {
    this.getCouponList();
  },
  methods: {
    // 执行搜索
    search() {
      this.searchParam.currentPage = 1;
      this.getCouponList();
    },
    async getCouponList() {
      let { list, total } = await this.$post(
        "/coupon/listByPage",
        this.searchParam
      );
      this.couponList = list;
      this.total = total;
    },
    add() {
      this.detailFlag = false;
      this.showNewDialog = true;
      this.formData = {
        name: "", // 名称
        reduce: "", // 优惠价格
        validDate: [],
        type: 1,
        isNewcomer: 1,
        full: "", // 满减的最小价格
        description: "", // 说明
        useType: 0,
      };
    },
    closeNewDialog() {
      this.showNewDialog = false;
    },
    // 新增优惠券
    async onSubmit() {
      this.$refs.formData.validate(async (valid) => {
        if (valid) {
          this.formData.startDt = this.formData.validDate[0];
          this.formData.endDt = this.formData.validDate[1];
          if (this.editFlag) {
            delete this.formData.updateDt;
            this.editFlag = false;
          }
          await this.$post("/coupon/enter", this.formData);
          this.getCouponList();
          this.$message.success("添加成功");
          this.showNewDialog = false;
        }
      });
    },
  },
  components: {},
};
</script>

<style lang="stylus" scoped>
@import './../../styl/variables.styl'
@import './../../styl/common.styl'


.el-dialog__body
  max-height: 60vh !important;
  overflow: scroll !important;
</style>
